import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './candidateProfile.css';
import { ProfileLeftContent } from './profileLeftContent';
import { ProfileRightContent } from './profileRightContent';
import { decodeJWT } from '../../../services/candidateService';
import { CandidateService } from '../../../services/candidateService';
import _ from 'lodash';
import { useCandidateUser } from '../candidateUserContext/candidateUserContext';
import CloseIcon from '../../../assets/images/Ic_close.png';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import { useRef } from 'react';
export const CandidateProfile = () => {
  const [loader, setLoader] = useState(true);
  const [searchParams] = useSearchParams();
  const [candidateData, setCandidateData] = useState({});
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const {
    candidateStatus,
    setCandidateStatus,
  } = useCandidateUser();


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshPage = () => {
    setRefreshKey(prev => prev + 1);
  };

  const fetchCandidateData = async () => {
    try {
      const token = window.localStorage.getItem('authToken');

      if (!token) {
        alert('Not logged in or missing token');
        navigate('/login');
        return;
      }

      const decoded = decodeJWT(token);
      console.log('Decoded token:', JSON.stringify(decoded));

      const candidateId = _.get(decoded, 'username', '');
      if (!candidateId || typeof candidateId !== 'string') {
        alert('Invalid token or missing candidate ID');
        return;
      }
      
      const response = await CandidateService.getCandidateById(candidateId);
      console.log('API Response:', JSON.stringify(response, null, 2));

      if (response.data && response.data.candidates && response.data.candidates.length > 0) {
        const candidate = response.data.candidates[0];
        setCandidateData(candidate);
        if (candidate.candidateApproved) {
          setCandidateStatus(candidate.candidateApproved);
        }
      } else {
        alert('Candidate data not found');
      }
    } catch (err) {
      console.error('API Error:', err);
      alert('Error fetching candidate data.');
    } finally {
      setLoader(false);
    }
  };

  const fetched = useRef(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;

    const justLoggedIn = localStorage.getItem('justLoggedIn') === 'true';

    fetchCandidateData().then(() => {
      if (justLoggedIn) {
        setTimeout(() => {
          setShowWelcomeModal(true);
          localStorage.removeItem('justLoggedIn');
        }, 2000);
      }
    });
  }, []);


  const handleSubmitAndContinue = async () => {
    try {
      await CandidatePostLoginService.submitForApproval();
      setIsSubmittedThisSession(true);
      setCandidateStatus("Y");
      setShowSubmitPrompt(false);

      triggerLogoutPopup();
    } catch (err) {
      console.error("Submit on exit failed", err);
      alert("Submission failed");
    }
  };

  return (
    <>
      {loader && (
        <div className="clientcandidate-loader-container">
          <div className="clientcandidate-loader"></div>
        </div>
      )}
      {!loader && candidateData && (
        <Container fluid key={refreshKey} className='cvleftrightcontainer'>
          <br></br>
          {/* Breadcrumb */}
          <div className="profile-work-experience-breadcrumb">
            <div className="breadcrumb-path">
              <span
                className="breadcrumb-link"
              >
                My Profile
              </span>
              <span className="breadcrumb-separator">/</span>

              <span className="breadcrumb-candidate-name">
                {_.get(candidateData, 'candidate.personalDetails.firstName')}{' '}
                {_.get(candidateData, 'candidate.personalDetails.lastName')}
              </span>
            </div>
          </div>
          <br></br>
          <Row className="client-candidate-information-row">
            <Col xs={12} xl={9} className="order-xl-first">
              <ProfileLeftContent
                candidateData={_.get(candidateData, 'candidate')}
                setCandidateData={updated =>
                  setCandidateData(prev => ({ ...prev, candidate: updated }))
                }
                fetchCandidateData={fetchCandidateData}
                refreshPage={refreshPage}
                candidateStatus={candidateStatus}
              />
            </Col>
            <Col xs={12} xl={3} className="order-xl-last">
              <ProfileRightContent
                candidateData={_.get(candidateData, 'candidate')}
              />
            </Col>
          </Row>
        </Container>
      )}
      <Modal
        show={showWelcomeModal}
        onHide={() => setShowWelcomeModal(false)}
        centered
        dialogClassName="awesome-modal"
        scrollable={false}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">

          <Modal.Title>
            Hi {_.get(candidateData, 'candidate.personalDetails.firstName', 'there')}!
          </Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={() => setShowWelcomeModal(false)}
            style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body >
          <strong>Welcome to Leaderly</strong> - India’s first exclusive platform for leadership hiring. <br /><br />
          You’re now part of a select network of senior professionals.<br />
          Please <strong>review your profile details and edit if needed</strong> to ensure they accurately reflect your skills and experience. Click/tap on <FontAwesomeIcon icon={faPen} size='sm' style={{ color: '#f35824' }} /> button to edit any section.<br /><br />
          Once you’ve reviewed everything — even if you haven’t made any edits — click <strong>Submit</strong> to send your profile for approval.
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowWelcomeModal(false)} className="approve-button" style={{ fontSize: '15px' }}>
            Okay, Got it!
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
